import React, { FC, useMemo } from "react";

import { ShopCarouselSliderArrow, InnerArrow } from "./ShopCarousel.styles";

const CarouselMainPageBannerPrevArrow: FC = (
  props: any //  eslint-disable-line @typescript-eslint/no-explicit-any
) => {
  const { onClick } = props;
  const currentSlide = props.currentSlide || 0;

  const isMobilePrevArrowDisabled = useMemo(() => {
    if (currentSlide === 0) {
      return true;
    }
  }, [currentSlide]);
  return (
    <ShopCarouselSliderArrow
      isRight={false}
      onClick={onClick}
      isMobilePrevArrowDisabled={isMobilePrevArrowDisabled}
    >
      <InnerArrow isRight={false} />
    </ShopCarouselSliderArrow>
  );
};

export default CarouselMainPageBannerPrevArrow;
